import React from 'react'

function Heading({heading}) {
    return (
        <div className="heading" data-aos="fade-up" data-aos-delay="400">
            {heading}
            <div className="heading__line" data-aos="fade-right" data-aos-delay="500"></div>
        </div>
    )
}

export default Heading



// WEBPACK FOOTER //
// ./src/Components/Heading/JavaScript/Heading.js